export enum AreaType {
  IA = "ia",
  OOA = "ooa",
}

export const AreaTypeLabel = {
  [AreaType.IA]: "IA",
  [AreaType.OOA]: "OOA",
};



// WEBPACK FOOTER //
// ./src/types/AreaType.tsx